import { useState, useMemo } from 'react';

export const useGameFilters = (gamesList) => {
    const [search, setSearch] = useState('');
    const [provider, setProvider] = useState(null);
    const [platform, setPlatform] = useState(null);
    const [hideInvalid, setHideInvalid] = useState(true);
    const [gameflexOnly, setGameflexOnly] = useState(false);

    const filteredGames = useMemo(() => {
        return gamesList.filter((game) => {
            // Updated search to include launchID
            const matchSearch =
                game.gameName.toLowerCase().includes(search.toLowerCase()) ||
                game.moduleId.toString().includes(search) ||
                (game.launchID && game.launchID.toLowerCase().includes(search.toLowerCase()));

            const matchProvider = provider ? game.provider === provider : true;
            const matchPlatform = platform ? game.platform === platform : true;
            const validGame = hideInvalid ? !game.invalidGame : true;
            const matchGameflex = gameflexOnly ? !!game.GameflexGameID : true;

            return matchSearch && matchProvider && matchPlatform && validGame && matchGameflex;
        });
    }, [search, provider, platform, hideInvalid, gameflexOnly, gamesList]);

    const filterOptions = useMemo(() => {
        return {
            platformList: [...new Set(gamesList.map((game) => game.platform))],
            providerList: [...new Set(gamesList.map((game) => game.provider).filter(Boolean))],
        };
    }, [gamesList]);

    return {
        filters: {
            search,
            setSearch,
            provider,
            setProvider,
            platform,
            setPlatform,
            hideInvalid,
            setHideInvalid,
            gameflexOnly,
            setGameflexOnly,
        },
        filterOptions,
        filteredGames,
    };
};